var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicalHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.999329 9.33328H5.33396L6.6673 7.33328L9.33396 11.3333L10.6673 9.33328H14.9993",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12C4.89803 13.8685 6.29375 15.0753 8.00065 16.6666C9.70755 15.0753 11.102 13.8685 12.5 12",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 6.95262C14.6622 5.99128 14.2769 5.07103 13.5955 4.39288C12.9141 3.71473 11.992 3.3338 11.0307 3.33328C10.4311 3.33746 9.84174 3.48801 9.31368 3.77186C8.78561 4.0557 8.33487 4.46424 8.00065 4.96195C7.66643 4.46424 7.21569 4.0557 6.68763 3.77186C6.15956 3.48801 5.57015 3.33746 4.97065 3.33328C4.0093 3.3338 3.08722 3.71473 2.40583 4.39288C1.72443 5.07103 1.33909 5.99128 1.33398 6.95262",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalHistory);
export default __webpack_public_path__ + "static/media/clinical-history.a584aa8580b205f02e7d752e601be888.svg";
export { ForwardRef as ReactComponent };